import power from '../../assets/illustrations/power.webp';
import fifty from '../../assets/illustrations/fifty.webp';
import hint from '../../assets/illustrations/hint.webp';
import fast from '../../assets/illustrations/fast.webp';
import slow from '../../assets/illustrations/slow.webp';
import comeback from '../../assets/illustrations/comeback.webp';
import streak from '../../assets/illustrations/streak.webp';
import point from '../../assets/illustrations/point.webp';
import calc from '../../assets/illustrations/calc.webp';
import lesson from '../../assets/illustrations/lesson.webp';
import gm from '../../assets/illustrations/gm.webp';
import party from '../../assets/illustrations/party.webp';
import first from '../../assets/illustrations/first.webp';
import second from '../../assets/illustrations/second.webp';
import third from '../../assets/illustrations/third.webp';
import trophy from '../../assets/illustrations/trophy.webp';
import leader from '../../assets/illustrations/leader.webp';
import single from '../../assets/illustrations/single.webp';
import teams from '../../assets/illustrations/teams.webp';
import rating from '../../assets/illustrations/rating.webp';
import timer from '../../assets/illustrations/timer.webp';
import heart from '../../assets/illustrations/heart.webp';
import email from '../../assets/illustrations/email.webp';
import gift from '../../assets/illustrations/gift.webp';
import target from '../../assets/illustrations/target.webp';
import balance from '../../assets/illustrations/balance.webp';
import star from '../../assets/illustrations/star.webp';
import drum from '../../assets/illustrations/drum.webp';
import celebrate from '../../assets/illustrations/celebrate.webp';
import rating_skull from '../../assets/illustrations/rating-skull.webp';
import rating_sick from '../../assets/illustrations/rating-sick.webp';
import rating_dizzy from '../../assets/illustrations/rating-dizzy.webp';
import rating_grimace from '../../assets/illustrations/rating-grimace.webp';
import rating_unsure from '../../assets/illustrations/rating-unsure.webp';
import rating_neutral from '../../assets/illustrations/rating-neutral.webp';
import rating_smile from '../../assets/illustrations/rating-smile.webp';
import rating_happy from '../../assets/illustrations/rating-happy.webp';
import rating_grin from '../../assets/illustrations/rating-grin.webp';
import rating_love from '../../assets/illustrations/rating-love.webp';
import rating_wow from '../../assets/illustrations/rating-wow.webp';
import sparkles from '../../assets/illustrations/sparkles.webp';
import players from '../../assets/illustrations/players.webp';
import ratingGroup from '../../assets/illustrations/rating-group.webp';
import ratingYours from '../../assets/illustrations/rating-yours.webp';
import wineYoung from '../../assets/illustrations/wine-young.webp';
import wineAged from '../../assets/illustrations/wine-aged.webp';
import wineVintage from '../../assets/illustrations/wine-vintage.webp';
import wineDeveloping from '../../assets/illustrations/wine-developing.webp';
import wineMature from '../../assets/illustrations/wine-mature.webp';
import wineBudget from '../../assets/illustrations/wine-budget.webp';
import viewTv from '../../assets/illustrations/view-tv.webp';
import viewPhone from '../../assets/illustrations/view-phone.webp';

export const illustrationAssets = {
  'view-tv': viewTv,
  'view-phone': viewPhone,
  'players': players,
  'rating-group': ratingGroup,
  'rating-yours': ratingYours,
  'wine-young': wineYoung,
  'wine-aged': wineAged,
  'wine-vintage': wineVintage,
  'wine-developing': wineDeveloping,
  'wine-mature': wineMature,
  'wine-budget': wineBudget,
  'power': power,
  'fifty': fifty,
  'hint': hint,
  'fast': fast,
  'slow': slow,
  'comeback': comeback,
  'streak': streak,
  'point': point,
  'calc': calc,
  'lesson': lesson,
  'gm': gm,
  'party': party,
  'first': first,
  'second': second,
  'third': third,
  'trophy': trophy,
  'leader': leader,
  'single': single,
  'teams': teams,
  'rating': rating,
  'timer': timer,
  'heart': heart,
  'email': email,
  'gift': gift,
  'target': target,
  'balance': balance,
  'star': star,
  'drum': drum,
  'celebrate': celebrate,
  'rating-skull': rating_skull,
  'rating-sick': rating_sick,
  'rating-dizzy': rating_dizzy,
  'rating-grimace': rating_grimace,
  'rating-unsure': rating_unsure,
  'rating-neutral': rating_neutral,
  'rating-smile': rating_smile,
  'rating-happy': rating_happy,
  'rating-grin': rating_grin,
  'rating-love': rating_love,
  'rating-wow': rating_wow,
  'sparkles': sparkles
};
